import { queryOptions } from '@tanstack/react-query';

import { filesWidgetApi } from './filesWidget.api';

export const filesWidgetOptions = {
  files: (groupName: string | undefined, size: number | undefined, enabled = true) =>
    queryOptions({
      queryKey: ['widget-files', size, groupName] as const,
      queryFn: () => filesWidgetApi.getFiles(groupName!, size),
      enabled: !!groupName && enabled
    })
};
